import { BaseApiService } from './base-api.service';
import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { buildAwsApi, setObjectParams } from '../util.class';
import { Store } from '@ngxs/store';
import { SessionStateModel, SessionState } from '../session';
import { CORE_CONFIGURATION } from '../configuration';

@Injectable({
  providedIn: 'root',
  deps: [BaseApiService]
})
export class AnchorsApiService {
  keyMapAWS: any;
  /**
   * Constructor
   * @param http api service
   */
  constructor(
    private http: BaseApiService,
    private store: Store,
    @Inject(CORE_CONFIGURATION) private config,
  ) {
    const { keyMapAWS }: SessionStateModel = this.store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }


  getLookup(anchorId: string,args?:any): Observable<any> {
    const apiAWS = buildAwsApi(this.keyMapAWS, 'anchor_lookup', { 'anchorId': anchorId });
    let params = new HttpParams();
    if (args) {
      Object.keys(args).forEach((v) => {
        params = params.set(v, args[v]);
      });
    }

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS,
      params,
      awsApi: apiAWS !== null
    });
  }
}
